"use client";

import { Phone } from "lucide-react";
import { Card } from "@/components/ui/card";
export default function TheArtOfExtraction() {
  const steps = [{
    number: "1",
    title: "Curated Selection",
    description: "Receive your personalized fragrance edit, hand-selected by our master perfumers based on your profile."
  }, {
    number: "2",
    title: "Artisanal Packaging",
    description: "Your scent is prepared in our atelier, wrapped in signature silk and sealed with wax."
  }, {
    number: "3",
    title: "White-Glove Delivery",
    description: "Experience the arrival of your fragrance, delivered with care to your doorstep."
  }, {
    number: "4",
    title: "The First Impression",
    description: "Unveil your new signature scent and begin your olfactory journey with Essence & Co.",
    badge: true
  }];
  return <section data-section-id="626" id="the-art-of-extraction" className="dark relative overflow-hidden bg-background py-20 md:py-28 lg:py-32">
      {}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <p className="mb-4 font-mono text-sm font-semibold uppercase tracking-[0.2em] text-primary">
            The Experience
          </p>
          <h2 className="font-default text-4xl font-semibold leading-tight text-foreground sm:text-5xl md:text-[56px] md:leading-[1.1]">
            The Art of Extraction
          </h2>
        </div>

        {}
        <div className="relative mt-16 md:mt-20">
          {}
          <div className="pointer-events-none absolute left-0 right-0 top-14 hidden lg:block" aria-hidden="true">
            <svg viewBox="0 0 1200 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="h-10 w-full" preserveAspectRatio="none">
              <path d="M 60 20 Q 200 -10, 350 20 T 650 20 T 950 20 T 1140 20" stroke="hsl(15 35% 65%)" strokeWidth="1" strokeLinecap="round" strokeDasharray="4 4" fill="none" opacity="0.4" />
            </svg>
          </div>

          <div className="grid grid-cols-1 gap-12 md:grid-cols-2 md:gap-10 lg:grid-cols-4 lg:gap-6">
            {steps.map((step, i) => <div key={i} data-index={i} className="relative flex flex-col items-center text-center">
                {}
                {i < steps.length - 1 && <div className="absolute left-1/2 top-32 hidden h-12 -translate-x-1/2 sm:block md:hidden" aria-hidden="true">
                    <svg viewBox="0 0 20 48" className="h-12 w-5" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M 10 0 Q 0 12, 10 24 T 10 48" stroke="hsl(15 35% 65%)" strokeWidth="1" strokeLinecap="round" fill="none" opacity="0.4" />
                    </svg>
                  </div>}

                {}
                <div className="relative">
                  <div className="flex h-28 w-28 items-center justify-center border border-border bg-card shadow-lg">
                    <span className="font-default text-5xl font-semibold text-foreground">
                      {step.number}
                    </span>
                  </div>

                  {}
                  {step.badge && <div className="absolute -right-4 -top-4 rotate-12 transform">
                      <div className="border border-primary bg-background px-3 py-1.5 shadow-md">
                        <span className="font-mono text-xs font-bold uppercase tracking-wider text-primary">
                          Exclusivity
                        </span>
                      </div>
                    </div>}
                </div>

                {}
                <div className="mt-6 px-2">
                  <h3 className="font-default text-2xl font-semibold leading-tight text-foreground">
                    {step.title}
                  </h3>
                  <p className="mt-3 text-base leading-relaxed text-muted-foreground">
                    {step.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        {}
        <div className="mt-16 flex justify-center md:mt-20">
          <Card className="flex w-full max-w-2xl flex-row items-center justify-center gap-3 border border-border bg-card px-6 py-5 shadow-md backdrop-blur-sm sm:gap-4 sm:px-8">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center border border-primary/20 bg-accent">
              <Phone className="h-5 w-5 text-primary" strokeWidth={1} />
            </div>
            <p className="text-sm leading-relaxed text-foreground sm:text-base">
              Concierge assistance? Text our atelier at{" "}
              <span className="font-semibold text-primary">
                (555) 888-SCENT
              </span>{" "}
              <span className="text-muted-foreground">— we respond within the hour.</span>
            </p>
          </Card>
        </div>
      </div>
    </section>;
}